// extracted by mini-css-extract-plugin
export var buttonContainer = "_9r-1";
export var fontSizeSelect = "_9r-3";
export var formatSelect = "_9r-2";
export var formats = "_9r-4";
export var hidden = "_9r-5";
export var icon = "_9r-6";
export var select = "_9r-0";